import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "program-img-wrapper" }
const _hoisted_2 = ["src", "onError"]
const _hoisted_3 = {
  key: 0,
  class: "orphan-playlists-wrap"
}
const _hoisted_4 = { class: "playlist-edit-scroll-inner" }
const _hoisted_5 = { class: "playlist-edit-subbar" }
const _hoisted_6 = { class: "playlist-edit-subbar__title" }
const _hoisted_7 = { class: "playlist-edit-subbar__chips" }
const _hoisted_8 = { class: "playlist-edit-chip playlist-edit-chip--tiny" }
const _hoisted_9 = { class: "playlist-edit-chip playlist-edit-chip--tiny" }
const _hoisted_10 = { class: "playlist-edit-form-grid" }
const _hoisted_11 = { class: "playlist-content playlist-edit-track-list" }
const _hoisted_12 = { class: "playlist-content playlist-edit-track-list" }
const _hoisted_13 = { class: "playlist-content playlist-edit-track-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Миксы",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: "main-background playlist-list-content",
        fullscreen: true,
        slot: "fixed",
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_segment, {
            value: _ctx.selectedListSegment,
            onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.listSegmentChange($event))),
            mode: "md",
            class: "custom-segment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_segment_button, { value: "all" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode("Все", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_segment_button, { value: "favourites" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("Избранное", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _withDirectives(_createVNode(_component_ion_content, { class: "bg-transparent" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_accordion_group, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program, programIdx) => {
                    return (_openBlock(), _createElementBlock("div", { key: programIdx }, [
                      _createVNode(_component_ion_accordion, {
                        class: "bg-transparent",
                        value: program.programName
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            slot: "header",
                            class: "program-item",
                            lines: "none",
                            color: "violet"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("img", {
                                  src: _ctx.programLogos[program.shortName || ''] || _ctx.getProgramImage(program.shortName || ''),
                                  alt: "program logo",
                                  onError: ($event: any) => (_ctx.onProgramLogoError(program.shortName))
                                }, null, 40, _hoisted_2)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_list, {
                            slot: "content",
                            class: "bg-transparent",
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_item, {
                                class: "release-item add-playlist-button",
                                onClick: ($event: any) => (_ctx.addPlayList(program.programName)),
                                color: "violet"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-center" }, {
                                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                      _createTextVNode("+", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"]), [
                                [_vShow, !_ctx.globalContext.offlineMode]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playlistsByPrograms[
                  program.shortName || ''
                ], (playlist, playlistIdx) => {
                                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                  name: "itemSliding-all",
                                  key: playlistIdx
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      class: "release-item",
                                      detail: true,
                                      color: "violet"
                                    }, {
                                      default: _withCtx(() => [
                                        (playlist.offline)
                                          ? (_openBlock(), _createBlock(_component_ion_icon, {
                                              key: 0,
                                              slot: "start",
                                              icon: _ctx.checkmarkCircle,
                                              color: "success",
                                              class: "offline-indicator"
                                            }, null, 8, ["icon"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ion_label, {
                                          class: "ion-text-center",
                                          onClick: ($event: any) => (_ctx.openPlaylist(playlist.id))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(playlist.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_item_options, { side: "start" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item_option, {
                                          color: "success",
                                          onClick: ($event: any) => (_ctx.copyPlaylist(playlist))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, {
                                              slot: "icon-only",
                                              icon: _ctx.copy
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_item_options, {
                                      side: "end",
                                      onIonSwipe: ($event: any) => (_ctx.addToFavourites(playlist.id, playlist.favourite ? false : true))
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_ion_item_option, {
                                          onClick: ($event: any) => (_ctx.changePlaylist(playlist.id)),
                                          color: "warning"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]), [
                                          [_vShow, !playlist.isRelease]
                                        ]),
                                        _createVNode(_component_ion_item_option, {
                                          color: "danger",
                                          onClick: ($event: any) => (_ctx.confirmRemovement(playlist.id))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _withDirectives(_createVNode(_component_ion_item_option, {
                                          onClick: ($event: any) => (_ctx.addToFavourites(playlist.id, true)),
                                          color: "success",
                                          expandable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: _ctx.starOutline }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]), [
                                          [_vShow, !playlist.favourite]
                                        ]),
                                        _withDirectives(_createVNode(_component_ion_item_option, {
                                          onClick: ($event: any) => (_ctx.addToFavourites(playlist.id, false)),
                                          color: "success",
                                          class: "white-icon",
                                          expandable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]), [
                                          [_vShow, playlist.favourite]
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["onIonSwipe"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              (_ctx.playlistsNotInAnyAccordion.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_ion_list, {
                      class: "bg-transparent",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          class: "program-item orphan-program-header",
                          lines: "none",
                          color: "medium"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap ion-padding-vertical" }, {
                              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                _createTextVNode(" Миксы вне списка программ (исправится после выбора программы при редактировании) ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playlistsNotInAnyAccordion, (playlist) => {
                          return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                            key: 'orphan-' + playlist.id,
                            name: "itemSliding-all"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                class: "release-item",
                                detail: true,
                                color: "medium"
                              }, {
                                default: _withCtx(() => [
                                  (playlist.offline)
                                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                                        key: 0,
                                        slot: "start",
                                        icon: _ctx.checkmarkCircle,
                                        color: "success",
                                        class: "offline-indicator"
                                      }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_label, {
                                    class: "ion-text-center",
                                    onClick: ($event: any) => (_ctx.openPlaylist(playlist.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(playlist.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_item_options, { side: "start" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item_option, {
                                    color: "success",
                                    onClick: ($event: any) => (_ctx.copyPlaylist(playlist))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: _ctx.copy
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_item_options, {
                                side: "end",
                                onIonSwipe: ($event: any) => (_ctx.addToFavourites(playlist.id, playlist.favourite ? false : true))
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_ion_item_option, {
                                    onClick: ($event: any) => (_ctx.changePlaylist(playlist.id)),
                                    color: "warning"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]), [
                                    [_vShow, !playlist.isRelease]
                                  ]),
                                  _createVNode(_component_ion_item_option, {
                                    color: "danger",
                                    onClick: ($event: any) => (_ctx.confirmRemovement(playlist.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _withDirectives(_createVNode(_component_ion_item_option, {
                                    onClick: ($event: any) => (_ctx.addToFavourites(playlist.id, true)),
                                    color: "success",
                                    expandable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.starOutline }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]), [
                                    [_vShow, !playlist.favourite]
                                  ]),
                                  _withDirectives(_createVNode(_component_ion_item_option, {
                                    onClick: ($event: any) => (_ctx.addToFavourites(playlist.id, false)),
                                    color: "success",
                                    class: "white-icon",
                                    expandable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]), [
                                    [_vShow, playlist.favourite]
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onIonSwipe"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_item, {
                class: "bg-transparent fake-item",
                lines: "none"
              }),
              _createVNode(_component_ion_modal, {
                "is-open": _ctx.showEditPlaylist,
                class: "playlist-edit-modal",
                onWillPresent: _cache[13] || (_cache[13] = ($event: any) => (_ctx.willPresentEditPlaylist())),
                onWillDismiss: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeTrackPreview()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_content, {
                    class: "playlist-container playlist-edit-body",
                    "scroll-y": true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_header, {
                        mode: "md",
                        class: "playlist-edit-header"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_toolbar, { class: "playlist-edit-toolbar" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_title, { class: "playlist-edit-toolbar-title" }, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                  _createTextVNode("Редактор микса", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_buttons, { slot: "end" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    class: "playlist-edit-save-btn",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.savePlaylist()))
                                  }, {
                                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                      _createTextVNode("Сохранить", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_button, {
                                    class: "playlist-header-button playlist-edit-close-btn",
                                    fill: "clear",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeEditPlaylist()))
                                  }, {
                                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                      _createTextVNode(" Закрыть ", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.editModalDisplayTitle), 1),
                          _createElementVNode("span", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, [
                              _createVNode(_component_ion_icon, { icon: _ctx.musicalNotesOutline }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.editSelectedTrackCount) + " " + _toDisplayString(_ctx.editTrackCountLabel), 1)
                            ]),
                            _createElementVNode("span", _hoisted_9, [
                              _createVNode(_component_ion_icon, { icon: _ctx.timeOutline }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.editTracksDurationFormatted), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_ion_item, {
                            lines: "none",
                            class: "playlist-edit-field playlist-edit-field--compact"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, {
                                position: "floating",
                                class: "playlist-edit-label"
                              }, {
                                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                  _createTextVNode("Название", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                type: "text",
                                modelValue: _ctx.editPlaylist.name,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editPlaylist.name) = $event)),
                                class: "playlist-name-input playlist-edit-input"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, {
                            lines: "none",
                            class: "playlist-edit-field playlist-edit-field--compact"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, {
                                position: "floating",
                                class: "playlist-edit-label"
                              }, {
                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                  _createTextVNode("Программа", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                value: _ctx.selectedProgram.programName,
                                modelValue: _ctx.selectedProgram,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedProgram) = $event)),
                                interface: "popover",
                                mode: "ios",
                                "interface-options": _ctx.customPopoverOptions,
                                class: "playlist-edit-select",
                                placeholder: "Программа",
                                onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.programChanged()))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: program.shortName,
                                      value: program
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(program.programName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["value", "modelValue", "interface-options"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_ion_item, {
                            lines: "none",
                            class: "playlist-edit-field playlist-edit-field--compact"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, {
                                position: "floating",
                                class: "playlist-edit-label"
                              }, {
                                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                  _createTextVNode("Релиз", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                value: _ctx.selectedRelease,
                                modelValue: _ctx.selectedRelease,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedRelease) = $event)),
                                interface: "popover",
                                mode: "ios",
                                "interface-options": _ctx.customPopoverOptions,
                                class: "playlist-edit-select",
                                placeholder: "Релиз",
                                onIonChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.releaseChanged()))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProgramReleases(_ctx.selectedProgram.programName), (release, idx) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: idx,
                                      value: release
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(release), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["value", "modelValue", "interface-options"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.selectedProgram.programName !== '']
                          ])
                        ]),
                        _createVNode(_component_ion_list, {
                          lines: "none",
                          class: "playlist-content playlist-edit-track-block"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_list_header, { class: "playlist-edit-section-head" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "playlist-header-label playlist-edit-section-title" }, {
                                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                    _createTextVNode("Треки микса", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { class: "playlist-edit-section-meta" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(_ctx.mediaUtils.getTotalPlaylistDuration(_ctx.selectedTracks))), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_ion_text, { class: "playlist-edit-hint" }, {
                              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                _createTextVNode(" Ниже откройте «Добавить из релиза» или выберите папку каталога и «Добавить из каталога». ", -1)
                              ]))]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.selectedRelease === '' && _ctx.selectedLibraryFolderId <= 0]
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_ion_reorder_group, {
                                onIonItemReorder: _cache[8] || (_cache[8] = ($event: any) => (_ctx.reorderPlaylist($event))),
                                disabled: false
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTracks, (track) => {
                                    return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                      key: track.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_reorder, { slot: "start" }),
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.mediaUtils.getTrackName(track)), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_label, { slot: "end" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(track.duration)), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_ion_item_options, { side: "end" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_item_option, {
                                              onClick: ($event: any) => (_ctx.removeTrack(track)),
                                              color: "danger"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createElementVNode("div", {
                          class: _normalizeClass(['playlist-edit-expand-wrap', _ctx.releaseTracksVisible ? 'playlist-edit-expand-wrap--open' : ''])
                        }, [
                          _createVNode(_component_ion_button, {
                            class: "playlist-edit-expand-btn",
                            fill: "outline",
                            size: "small",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showReleaseTracks()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                icon: _ctx.add,
                                class: _normalizeClass([_ctx.releaseTracksVisible ? 'close-button' : ''])
                              }, null, 8, ["icon", "class"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.releaseTracksVisible ? "Скрыть треки релиза" : "Добавить из релиза"), 1)
                            ]),
                            _: 1
                          })
                        ], 2), [
                          [_vShow, _ctx.selectedRelease !== '']
                        ]),
                        _withDirectives(_createVNode(_component_ion_list, {
                          lines: "none",
                          class: "playlist-content playlist-edit-track-block ion-margin-bottom"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_list_header, { class: "playlist-edit-section-head" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "playlist-header-label playlist-edit-section-title" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(`${_ctx.selectedProgram.programName} · ${_ctx.selectedRelease}`), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { class: "playlist-edit-section-meta" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(_ctx.mediaUtils.getTotalPlaylistDuration(_ctx.musicList))), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicList, (track, idx) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  key: idx,
                                  class: "preview-item"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("div", {
                                      class: "preview-progress",
                                      style: _normalizeStyle({ width: `${(_ctx.previewCurrentPosition / _ctx.previewDuration) * 100}%` })
                                    }, null, 4), [
                                      [_vShow, track.id == _ctx.previewTrackId]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_icon, {
                                      onClick: ($event: any) => (_ctx.previewTrack(track)),
                                      slot: "start",
                                      icon: _ctx.previewPlaying && track.id == _ctx.previewTrackId ? _ctx.pause : _ctx.play,
                                      class: "play-button"
                                    }, null, 8, ["onClick", "icon"]), [
                                      [_vShow, !_ctx.previewLoading || track.id !== _ctx.previewTrackId]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_spinner, {
                                      slot: "start",
                                      name: "bubbles"
                                    }, null, 512), [
                                      [_vShow, track.id == _ctx.previewTrackId && _ctx.previewLoading]
                                    ]),
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.mediaUtils.getTrackName(track)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_label, { slot: "end" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(track.duration)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_icon, {
                                      slot: "end",
                                      icon: _ctx.add,
                                      onClick: ($event: any) => (_ctx.addTrack(track)),
                                      class: _normalizeClass([_ctx.isAdded(track) ? 'close-button danger-button' : 'add-button'])
                                    }, null, 8, ["icon", "onClick", "class"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.releaseTracksVisible]
                        ]),
                        _createVNode(_component_ion_item, {
                          lines: "none",
                          class: "playlist-edit-field playlist-edit-field--compact"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              position: "floating",
                              class: "playlist-edit-label"
                            }, {
                              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                _createTextVNode("Каталог музыки", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_ion_select, {
                              modelValue: _ctx.selectedLibraryFolderId,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedLibraryFolderId) = $event)),
                              interface: "popover",
                              mode: "ios",
                              class: "playlist-edit-select",
                              placeholder: "Папка",
                              onIonChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onLibraryFolderChange()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_select_option, { value: 0 }, {
                                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                    _createTextVNode("Не выбрано", -1)
                                  ]))]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.libraryFolders, (lf) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: lf.id,
                                    value: lf.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(lf.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createElementVNode("div", {
                          class: _normalizeClass(['playlist-edit-expand-wrap', _ctx.libraryTracksVisible ? 'playlist-edit-expand-wrap--open' : ''])
                        }, [
                          _createVNode(_component_ion_button, {
                            class: "playlist-edit-expand-btn",
                            fill: "outline",
                            size: "small",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toggleLibraryTracks()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                icon: _ctx.add,
                                class: _normalizeClass([_ctx.libraryTracksVisible ? 'close-button' : ''])
                              }, null, 8, ["icon", "class"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.libraryTracksVisible ? "Скрыть каталог" : "Добавить из каталога"), 1)
                            ]),
                            _: 1
                          })
                        ], 2), [
                          [_vShow, _ctx.selectedLibraryFolderId > 0]
                        ]),
                        _withDirectives(_createVNode(_component_ion_list, {
                          lines: "none",
                          class: "playlist-content playlist-edit-track-block ion-margin-bottom"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_list_header, { class: "playlist-edit-section-head" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "playlist-header-label playlist-edit-section-title" }, {
                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                    _createTextVNode("Треки каталога", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { class: "playlist-edit-section-meta" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(_ctx.mediaUtils.getTotalPlaylistDuration(_ctx.libraryMusicList))), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.libraryMusicList, (track, lidx) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 'lib-' + track.id + lidx,
                                  class: "preview-item"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_ion_icon, {
                                      onClick: ($event: any) => (_ctx.previewTrack(track)),
                                      slot: "start",
                                      icon: _ctx.previewPlaying && track.id == _ctx.previewTrackId ? _ctx.pause : _ctx.play,
                                      class: "play-button"
                                    }, null, 8, ["onClick", "icon"]), [
                                      [_vShow, !_ctx.previewLoading || track.id !== _ctx.previewTrackId]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_spinner, {
                                      slot: "start",
                                      name: "bubbles"
                                    }, null, 512), [
                                      [_vShow, track.id == _ctx.previewTrackId && _ctx.previewLoading]
                                    ]),
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.mediaUtils.getTrackName(track)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_label, { slot: "end" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(track.duration)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_icon, {
                                      slot: "end",
                                      icon: _ctx.add,
                                      onClick: ($event: any) => (_ctx.addTrack(track)),
                                      class: _normalizeClass([_ctx.isAdded(track) ? 'close-button danger-button' : 'add-button'])
                                    }, null, 8, ["icon", "onClick", "class"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.libraryTracksVisible && _ctx.selectedLibraryFolderId > 0]
                        ]),
                        _cache[30] || (_cache[30] = _createElementVNode("div", {
                          class: "playlist-edit-scroll-pad",
                          "aria-hidden": "true"
                        }, null, -1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["is-open"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.selectedListSegment == 'all']
          ]),
          _withDirectives(_createVNode(_component_ion_content, { class: "bg-transparent favourites-content" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program, programIdx) => {
                return (_openBlock(), _createElementBlock("div", { key: programIdx }, [
                  _createVNode(_component_ion_list, {
                    slot: "content",
                    class: "bg-transparent",
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playlistsByPrograms[
              program.shortName || ''
            ], (playlist, playlistIdx) => {
                        return (_openBlock(), _createElementBlock("div", { key: playlistIdx }, [
                          (playlist.favourite)
                            ? (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                key: 0,
                                name: "itemSliding-favourites"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    class: "release-item release-favourite-item",
                                    detail: true,
                                    color: "violet"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        class: "ion-text-center",
                                        onClick: ($event: any) => (_ctx.openPlaylist(playlist.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(`${playlist.programName} -
                                      ${playlist.name}`), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item_options, { side: "start" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item_option, {
                                        color: "success",
                                        onClick: ($event: any) => (_ctx.copyPlaylist(playlist))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "icon-only",
                                            icon: _ctx.copy
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item_options, {
                                    side: "end",
                                    onIonSwipe: ($event: any) => (_ctx.addToFavourites(playlist.id, playlist.favourite ? false : true))
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createVNode(_component_ion_item_option, {
                                        onClick: ($event: any) => (_ctx.changePlaylist(playlist.id)),
                                        color: "warning"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]), [
                                        [_vShow, !playlist.isRelease]
                                      ]),
                                      _createVNode(_component_ion_item_option, {
                                        color: "danger",
                                        onClick: ($event: any) => (_ctx.confirmRemovement(playlist.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      _withDirectives(_createVNode(_component_ion_item_option, {
                                        onClick: ($event: any) => (_ctx.addToFavourites(playlist.id, true)),
                                        color: "success",
                                        expandable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.starOutline }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]), [
                                        [_vShow, !playlist.favourite]
                                      ]),
                                      _withDirectives(_createVNode(_component_ion_item_option, {
                                        onClick: ($event: any) => (_ctx.addToFavourites(playlist.id, false)),
                                        color: "success",
                                        expandable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]), [
                                        [_vShow, playlist.favourite]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["onIonSwipe"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128)),
              _createVNode(_component_ion_item, {
                class: "bg-transparent fake-item",
                lines: "none"
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.selectedListSegment == 'favourites']
          ]),
          _createVNode(_component_ion_loading, {
            cssClass: "liga-loading",
            spinner: "lines",
            "is-open": _ctx.isSavingRef,
            message: "Сохранение..."
          }, null, 8, ["is-open"])
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}